import { ChevronDown, Download } from "lucide-react"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

/**
 * document-editor.md's `ConsentDownload` (DE-consent) — the two client
 * consent forms, printed from the shared `ConsentSheet`/`consentFieldValue`
 * pair which doesn't exist in this package yet. The trigger and its two
 * documented menu items are real; the actual print/PDF generation is
 * deferred (needs the shared print-sheet component, not this page's own
 * scope) rather than fabricated.
 */
export function ConsentDownload() {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline">
          <Download data-icon="inline-start" />
          Скачати згоди...
          <ChevronDown data-icon="inline-end" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem>
          <Download />
          Згода на обробку персональних даних
        </DropdownMenuItem>
        <DropdownMenuItem>
          <Download />
          Згода на проходження ОТК
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
